<template>
  <div class="get-the-look__product q-position-relative q-row">
    <div v-if="filteredLeftAccesoriesProducts.length > 0" class="accesories_left-container q-position-absolute q-d-flex q-col-3 q-px-0 ">
      <div v-for="product in filteredLeftAccesoriesProducts" :key="product.productId" class="shoes hexagon small"
           :style="{ backgroundImage: 'url('+generateStaticImage(product.product.image_link, 400, null)+')',
            backgroundSize: 'cover', backgroundPosition:'center', }">
      </div>
    </div>
    <div class="container q-d-flex q-col-5 q-px-0 " :class="{'q-col-6': filteredMainProducts.length === 1}"
         :style="{flexDirection: filteredMainProducts.length === 1 ? 'row' : 'column'}">
      <div v-for="product in filteredMainProducts" :key="product.productId" class="topwear hexagon big" :style="{ backgroundImage: 'url('+generateStaticImage(product.product.image_link, 400, null)+')',
            backgroundSize: 'cover', backgroundPosition:'center', }">
      </div>

    </div>
    <div class="accesories_right-container q-position-absolute q-d-flex q-col-3 q-px-0"
         :style="{justifyContent: filteredHatProducts.length === 1 ? 'space-between' : 'flex-end'}">
      <div v-for="product in filteredHatProducts" :key="product.productId" class="hat hexagon small"
           :style="{ backgroundImage: 'url('+generateStaticImage(product.product.image_link, 400, null)+')',
            backgroundSize: 'cover', backgroundPosition:'center bottom', }">
      </div>
      <div v-for="product in filteredShoesProducts" :key="product.productId" class="shoes hexagon small"
           :style="{ backgroundImage: 'url('+generateStaticImage(product.product.image_link, 400, null)+')',
            backgroundSize: 'cover', backgroundPosition:'center bottom', }">
      </div>
    </div>
  </div>

</template>
<script setup lang="ts">
import {generateStaticImage, formatPrice, getDiscount, parsePrice} from '@/core/utils'
import {defineProps, ref, PropType, computed} from 'vue'

const props = defineProps({
  products: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});
// console.log('produkty w kolażu', props.products)
const getProductCategoriesByProductId = (products, categoryName = 'categories_VALUE_2') => {
  return products.map((product) => {
    const firstVariant = product?.variants[0]
    return {
      'productId': product.id,
      'croppedCategory': findKeyByValue(categoriesMapping, firstVariant[categoryName]),
      'productCategory': firstVariant[categoryName],
      'product': product
    }
  })
}

function findKeyByValue(object, value) {
  for (var key in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key)) {
      // console.log('findKeyByValue', key, value)
      if (object[key].indexOf(value) > -1) {
        return key;
      }
    }
  }
  return null;
}


const categoriesMapping = {
  "Backpack": [],
  "Bag": [
    "Torby podróżne",
    "Walizki",
    "Torby męskie",
    "Torby na laptopa",
    "Plecaki"
  ],
  "Belt": ["Paski"],
  "Bracelet": [],
  "Dress": ["Sukienki", "Sukienki i spódnice"],
  "Earrings": ["hp_damskie_akcesoria_bizuteria", "Biżuteria"],
  "Glasses": ["Okulary"],
  "Glove": ["Rękawiczki", "Rękawice"],
  "Handbag": ["Torby podróżne", "Walizki", "Torebki", "Plecaki"],
  "Hat": ["Nakrycia głowy", "Czapki i kapelusze", "Czapki"],
  "Luggage & bags": [
    "Torby podróżne",
    "Walizki",
    "Torby męskie",
    "Torby na laptopa",
    "Plecaki"
  ],
  "Miniskirt": ["Spódnice", "Sukienki i spódnice"],
  "Necklace": ["hp_damskie_akcesoria_bizuteria", "Biżuteria"],
  "Outerwear": [
    "Płaszcze",
    "Marynarki",
    "Kurtki",
    "Bluzy",
    "Kamizelki",
    "Płaszcze",
    "Marynarki",
    "Kurtki",
    "Kamizelki",
    "Odzież wierzchnia",
    "Kurtki narciarskie"
  ],
  "Overall": ["Kombinezony", "Body", "Piżamy"],
  "Pants": [
    "Legginsy",
    "Spodnie",
    "Spodenki i legginsy",
    "Spodnie narciarskie"
  ],
  "Scarf": [
    "hp_damskie_akcesoria_szaliki_i_chusty",
    "Szaliki i chusty",
    "Chusty",
    "Kominy",
    "Szaliki"
  ],
  "Shoe": [
    "hp_damskie_obuwie_trzewiki_i_trapery",
    "Obuwie",
    "hp_meskie_obuwie_botki_i_sztyblety",
    "hp_damskie_obuwie_szpilki_i_czolenka",
    "Klapki",
    "Klapki i japonki",
    "Sandały",
    "Buciki",
    "Mokasyny",
    "Szpilki i czółenka",
    "Espadryle",
    "Botki",
    "Kozaki",
    "Botki i sztyblety",
    "Półbuty",
    "Sneakersy",
    "Trzewiki i trapery",
    "Kalosze",
    "Trampki",
    "Baleriny",
    "Koturny",
    "Pantofle",
    "Kapcie",
    "Sztyblety",
    "Obuwie",
    "Botki i kozaki",
    "Sandały",
    "Botki i trzewiki",
    "Trampki",
    "Baleriny",
    "Kalosze",
    "Kapcie",
    "Półbuty",
    "Trzewiki",
    "Klapki"
  ],
  "Shorts": ["Szorty", "Spodenki"],
  "Skirt": ["Spódnice", "Sukienki i spódnice"],
  "Sunglasses": [],
  "Top": [
    "hp_dziecko_chlopiec_odziez_koszulki",
    "hp_dziecko_dziewczynka_odziez_koszulki_i_topy",
    "hp_dziecko_dziewczynka_odziez_bluzki_i_koszule",
    "Longsleevy",
    "T-shirty",
    "Koszule",
    "Topy",
    "Polo",
    "Golfy",
    "Kardigany",
    "Bluzy",
    "Swetry",
    "Garnitury",
    "Bluzki",
    "Koszulki i topy",
    "Koszule",
    "Swetry",
    "Koszulki",
    "Bluzy i swetry",
    "Longsleevy",
    "Bluzki i koszule",
    "Bluzy"
  ],
  "Wallet": ["Portfele", "Saszetki"],
  "Watch": [],
  "blacklist": [
    "hp_dziecko_dla_noworodkow_akcesoria_posciel_i_poduszki",
    "hp_dziecko_dziewczynka_odziez_sukienki_i_spodnice",
    "hp_dziecko_dla_noworodkow_akcesoria_smoczki",
    "hp_dziecko_dla_noworodkow_akcesoria_akcesoria_do_karmienia",
    "hp_dziecko_dla_noworodkow_akcesoria_reczniki",
    "hp_dom_dekoracje_wystroj_i_wnetrze_dekoracje_stojace",
    "hp_damskie_bielizna_komplety_bielizny",
    "hp_damskie_bielizna_skarpety_i_rajstopy",
    "hp_dziecko_dla_noworodkow_akcesoria_koce",
    "Zabawki",
    "hp_damskie_bielizna_odziez_plazowa",
    "Bielizna",
    "Gry i planszówki",
    "Koce i pledy",
    "Odżywki do włosów",
    "Akcesoria spa",
    "Piórniki",
    "Szampony do włosów",
    "Dywany",
    "Przybory szkolne",
    "Kalendarze",
    "Tekstylia kuchenne",
    "Zapachy",
    "Stylizacja do włosów",
    "Artykuły plastyczne",
    "Tekstylia",
    "Krawaty",
    "Artykuły do pisania",
    "Ściereczki kuchenne",
    "Ozdoby do włosów",
    "Obrusy",
    "Lusterka podświetlane",
    "Figurki i akcesoria",
    "Akcesoria łazienkowe",
    "Kremy do twarzy",
    "Wystrój i wnętrze",
    "Lalki i akcesoria",
    "Książki",
    "Bielizna termiczna",
    "Akcesoria dla zwierząt",
    "Serwowanie potraw",
    "Zabawki dla dzieci",
    "Akcesoria do makijażu",
    "Kosmetyki dla dzieci",
    "Skarpety",
    "Kremy pod oczy",
    "Produkty do ust",
    "Zestawy kosmetyków",
    "Dywaniki łazienkowe",
    "Muchy",
    "Klocki",
    "Ładowarki",
    "Komplety",
    "Akcesoria do włosów",
    "Zabawki do kąpieli",
    "Masażery manualne",
    "Kredki i eyelinery",
    "Wycieraczki",
    "Słuchawki",
    "Akcesoria sportowe",
    "Kosmetyczki",
    "Kąpielówki",
    "Zasłony",
    "Etui na telefon",
    "Zegarki",
    "Poduszki",
    "Bielizna",
    "Masażery do twarzy i ciała",
    "Komplety bielizny",
    "Kreatywna zabawa",
    "Tekstylia do jadalni",
    "Kremy do rąk",
    "Peelingi i maski do twarzy",
    "Kamery",
    "Pościel",
    "Kuferki",
    "Organizery",
    "Akcesoria kuchenne",
    "Maskotki",
    "Dekoracje",
    "Puzzle i układanki",
    "Parasole",
    "Kremy do stóp",
    "Majtki",
    "Kostiumy kąpielowe",
    "Akcesoria do serwowania",
    "Zabawki interaktywne",
    "Głośniki",
    "Akcesoria papiernicze",
    "Kosmetyki dla mężczyzn",
    "Kosmetyki do mycia",
    "Mydła",
    "Balkon i ogród",
    "Pojazdy zdalnie sterowane",
    "Samochody i pojazdy",
    "Powerbanki",
    "Biustonosze",
    "Maski do ciała",
    "Skarpety i rajstopy",
    "Palety do makijażu",
    "Zestawy podróżne",
    "Zabawa na zewnątrz",
    "Olejki",
    "Demakijaż",
    "Balsamy do ciała",
    "Narzuty",
    "Breloki",
    "Maseczki",
    "Serwowanie napojów",
    "Gorsety",
    "Kimona",
    "Szlafroki",
    "Ręczniki",
    "Nauszniki",
    "Sole i kule do kąpieli",
    "Dresy",
    "Fartuchy kuchenne",
    "Koszule nocne",
    "nożyce",
    "Lunchboxy",
    "Hobby",
    "Majtki",
    "Dozowniki na mydło",
    "Pojemniki do przechowywania",
    "Parasole",
    "AGD",
    "Doniczki i osłonki",
    "Skarpetki",
    "Ręczniki",
    "Smoczki",
    "Pokój dziecięcy",
    "Ramki na zdjęcia",
    "Meble",
    "Torby termiczne",
    "Chlebaki",
    "Talerze",
    "Pojemniki na przyprawy",
    "Filiżanki",
    "Koce",
    "Garnki i rondle",
    "Nakrycie stołu",
    "Zapachy",
    "Butelki podróżne i termosy",
    "Tekstylia",
    "Dekoracje stojące",
    "Komplety niemowlęce",
    "chwytaki",
    "Wazony",
    "Szczotki do wc",
    "Uchwyty do mebli",
    "Przybory kuchenne",
    "Figurki",
    "Dekoracje ścienne",
    "Deski do krojenia",
    "Dywaniki łazienkowe",
    "Maty piknikowe",
    "Młynki do przypraw",
    "Lustra",
    "Hamaki i huśtawki",
    "Naczynia na owoce",
    "Kostiumy kąpielowe",
    "Miski",
    "Komplety ogrodowe",
    "Akcesoria ogrodowe",
    "Patelnie",
    "Dzbanki i karafki",
    "Zaparzacze",
    "Komplety",
    "Kubki na szczoteczki",
    "Zabawki niemowlęce",
    "Akcesoria do przyrządzania",
    "Poduszki",
    "Lampy",
    "Bielizna",
    "Dekoracje",
    "Akcesoria kuchenne",
    "Stopery do drzwi",
    "Sztućce",
    "Zastawa stołowa",
    "Bielizna termiczna",
    "Formy do pieczenia",
    "Szklanki i kieliszki",
    "Śpiochy i pajace",
    "Noże",
    "Skarpety",
    "Szelki",
    "Kubki",
    "Naczynia do serwowania",
    "Zegary",
    "Kąpielówki",
    "Szlafroki",
    "Opaski do włosów",
    "Akcesoria sportowe",
    "Świeczniki",
    "Biustonosze",
    "Kosze na śmieci",
    "Oświetlenie",
    "Mydelniczki",
    "Pościel i poduszki",
    "Przechowywanie",
    "Piżamy",
    "Akcesoria do karmienia",
    "Zestawy do przyrządzania",
    "Łopatki ogrodowe",
    "Rośliny sztuczne",
    "Świeczki",
    "Akcesoria świąteczne",
    "Akcesoria barowe"
  ]
}

const CATEGORY_NAME = 'categories_VALUE_2'

const preparedProducts = getProductCategoriesByProductId(props.products, CATEGORY_NAME)

const shoesCategories = ['Shoe']
const hatCategories = ['Hat', 'Sunglasses', 'Earrings', 'Glasses', 'Necklace', 'Bracelet', 'Glove', 'Scarf']
const centerCategories = ['Dress', 'Miniskirt', 'Outerwear', 'Overall', 'Pants', 'Shorts', 'Skirt', 'Top']
const leftCategories = ['Backpack', 'Bag', 'Belt', 'Handbag', 'Luggage & bags', 'Wallet', 'Watch']


const filteredShoesProducts = computed(() => {
  return preparedProducts.filter(product => {
    return shoesCategories.includes(product.croppedCategory);
  });
});
const filteredHatProducts = computed(() => {
  return preparedProducts.filter(product => {
    return hatCategories.includes(product.croppedCategory);
  });
});


const filteredMainProducts = computed(() => {
  return preparedProducts.filter(product => {
    return centerCategories.includes(product.croppedCategory);
  });
});

const filteredLeftAccesoriesProducts = computed(() => {
  return preparedProducts.filter(product => {
    return leftCategories.includes(product.croppedCategory);
  });
});


</script>
<style scoped>
.container {
  flex-direction: column;
  justify-content: space-evenly;
}

.accesories_left-container, .accesories_right-container {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex !important;
  flex-direction: column;
  justify-content: space-evenly;
}

.accesories_right-container {
  right: 0;
}

.hexagon {
  background: transparent no-repeat;
}

.hexagon.big {
  z-index: 1;
  width: 100%;
  min-height: 250px;
  max-height: 100%;
}

.hexagon.small {
  width: 100%;
  height: 33%;
  z-index: 5;
}


</style>